// extracted by mini-css-extract-plugin
module.exports = {"item-stub":"ItemStub_item-stub__msoJP","item-stub__link":"ItemStub_item-stub__link__1Lf80","item-stub__link--active":"ItemStub_item-stub__link--active__rUf3h"};